enum NewsStatusEnum {
  portalLevelValidated = 'portal-level-validated',
  portalLevelValidationPending = 'portal-level-validation-pending',
  portalDraft = 'portal-draft',
  companyLevelValidated = 'company-level-validated',
  companyDraft = 'company-draft',
  suspended = 'suspended',
  ghost = 'ghost',
  deleted = 'deleted',
  all = 'all'
}

enum NewsTypeEnum {
  companies = 'companies',
  portal = 'portal',
  all = 'all'
}

export { NewsTypeEnum, NewsStatusEnum };
